// extracted by mini-css-extract-plugin
export default {"checkout_btn":"Checkoutbtn_checkout_btn__n1MlA"};